import React, { Fragment, useState, useCallback, useEffect } from 'react';
import { Button, CssBaseline, TextField, Link, Grid, Typography, List, ListItem } from '@material-ui/core';
import { makeStyles, createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useHistory } from 'react-router-dom';
import { Box, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, IconButton } from '@material-ui/core';

import axios from 'axios';

import { COLORS } from '../../shared/Theme';
import { SIcon } from '../../shared/Icon';

import { admin as v_admin, basic, Values, SNACKBAR_TIME, edu } from '../../request/values';

const SERVER = basic.server;

const useStyles = makeStyles((theme: any) => ({
	background: {
		position: 'absolute',
		top: 0,
		width: '100vw',
		height: '100vh',
		background: `url("/images/background.png")`,
	},
	container2: {
		padding: 0,
		display: 'grid',
		gridTemplateRows: '1fr 2.5fr 6fr 1fr 1fr',
		height: '98vh',
		marginTop: '2vh',
	},
	playImage: {
		width: '50%',
	},
	playImageSection: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	logoSection: {
		display: 'flex',
		justifyContent: 'center',
		flex: 1,
		alignItems: 'flex-end',
		margin: '3vh 0',
	},
	logobutton: {
		border: 'none',
		backgroundColor: 'transparent',
	},
	buttonFont: {
		//color: `${COLORS.WHITE}`,
		fontSize: '1.1vw',
	},
	movePageButton: {
		flexDirection: 'column',
		fontSize: '1.5vw',
		margin: 'auto',
		color: `${COLORS.WHITE}`,
	},
	playButton: {
		width: '10vw',
		height: 'auto',
		marginLeft: '5vw',
	},
	playButtonImage: {
		width: '100%',
	},
	trophySection: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		margin: '5vh 0',
	},
	ExceptWinner: {
		backgroundColor: `${COLORS.LIGHT_GREY}`,
		width: '10vh',
		height: '9vh',
		marginBottom: 17,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: 20.7,
		boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
		'& img': {
			width: '8vh',
			height: 'auto',
		},
	},
	Winner: {
		backgroundColor: `${COLORS.WATER_BLUE}`,
		width: '15vh',
		height: '13vh',
		marginRight: 60,
		marginLeft: 60,
		marginBottom: 17,

		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: 20.7,
		boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
		'& img': {
			width: '13vh',
			height: 'auto',
		},
	},
	table: {
		display: 'grid',
		gridTemplateRows: '50px 1fr',
		width: '94%',
		//height: '50vh',
		margin: '1% 3%',
		backgroundColor: 'transparent',
		'& #title': {
			display: 'grid',
			gridTemplateColumns: '1fr 4fr 2fr 10px 2fr 10px 2fr',
			border: 'solid',
			borderWidth: '0 0 2px 0',
			//background: 'none',
			'& span': {
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				'& p': {
					fontSize: '2.3vh',
					fontWeight: 'bolder',
				},
			},
		},
		'& #classinfo': {
			overflow: 'scroll',
			overflowX: 'hidden',
			borderRadius: '0 0 0 10px',
		},
	},
	memberInfo: {
		display: 'grid',
		gridTemplateColumns: '1fr 4fr 2fr 10px 2fr 10px 2fr',
		padding: '20px 0',
	},
	buttonLabel: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		fontSize: '2.3vh',
		fontFamily: 'NanumB',
		lineHeight: '21px',
	},
	blank: {
		height: '40px',
	},
	winnerContent: {
		'& th, td': {
			color: `${COLORS.WATER_BLUE}`,
		},
	},
	footer: {
		textAlign: 'center',
		marginTop: '3vh',
		'& img': {
			width: 166,
		},
	},
	playStartUpLogoSection: {
		display: 'flex',
		justifyContent: 'center',
		flex: 1,
		alignItems: 'flex-end',
		margin: 'auto 0',
		'& img': {
			width: '25vw',
			height: 'auto',
		},
	},
	upperSection: {
		display: 'grid',
		gridTemplateColumns: '1fr 4fr 1fr',
	},
	infoButton: {
		backgroundColor: `${COLORS.WATER_BLUE}`,
		color: `${COLORS.WHITE}`,
		borderRadius: '10px',
		margin: '0.7vh',
		width: '6vw',
		'&:hover': {
			color: `${COLORS.WATER_BLUE}`,
		},
	},
	endingSection: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
	},
	endingText: {
		fontSize: '3vw',
		fontWeight: 'bold',
		marginBottom: '10vw',
	},
}));

const SubAdminOpenRanking: React.FC<any> = (props) => {
	const classes = useStyles();

	const [rank, setRank] = useState([
		{
			company_name: '테스트',
			stock: 180000,
			loan: 0,
			loan_interest: 0,
			capital: 180000,
			order_inventory: 0,
			used_mat: 0,
			license_stock: 10000,
		},
		{
			company_name: '테스트1',
			stock: 190000,
			loan: 0,
			loan_interest: 0,
			capital: 190000,
			order_inventory: 0,
			used_mat: 0,
			license_stock: 10000,
		},
		{
			company_name: '테스트2',
			stock: 200000,
			loan: 0,
			loan_interest: 0,
			capital: 200000,
			order_inventory: 0,
			used_mat: 0,
			license_stock: 10000,
		},
	]);

	const history = useHistory();
	const { member } = props;

	const state: any = history.location.state;
	const classCode = state.code;
	const className = state.name;

	const getRankContent = () => {
		console.log(classCode);
		axios({
			method: 'POST',
			data: {
				class_code: classCode,
			},
			withCredentials: true,
			url: SERVER + edu.path + edu.class_rank_content,
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log('data?', data);
				if (data.code == Values.SUCCESS_CODE) {
					setRank(data.rank);
				} else {
				}
			});
	};

	useEffect(() => {
		getRankContent();
	}, []);

	const movePage = () => {
		history.push({
			pathname: '/subAdminClassList',
		});
	};

	return (
		<div className={classes.background}>
			<Container component="main" className={classes.container2}>
				<CssBaseline />

				<div className={classes.upperSection}>
					<div></div>
					<div className={classes.playStartUpLogoSection}>
						<img src="/images/ranking/logo.webp" />
					</div>
					<div className={classes.movePageButton}>
						<Button onClick={(e) => movePage()} className={classes.infoButton}>
							<Typography className={classes.buttonFont}>메인으로</Typography>
						</Button>
					</div>
				</div>

				<div className={classes.trophySection}>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							textAlign: 'center',
						}}
					>
						<Box className={classes.ExceptWinner}>
							<img src="/images/ranking/silver.webp" />
						</Box>
						<Typography style={{ fontSize: '2.6vh' }}>{rank[1] != undefined ? rank[1].company_name : ''}</Typography>
					</div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							textAlign: 'center',
						}}
					>
						<Box className={classes.Winner}>
							<img src="/images/ranking/gold.webp" />
						</Box>
						<Typography style={{ fontSize: '3.5vh' }}>{rank[0] != undefined ? rank[0].company_name : ''}</Typography>
					</div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							textAlign: 'center',
						}}
					>
						<Box className={classes.ExceptWinner}>
							<img src="/images/ranking/bronze.webp" />
						</Box>
						<Typography style={{ fontSize: '2.6vh' }}>{rank[2] != undefined ? rank[2].company_name : ''}</Typography>
					</div>
				</div>

				<div className={classes.table}>
					<div id="title">
						<span>
							<Typography>순위</Typography>
						</span>
						<span>
							<Typography>기업명</Typography>
						</span>
						<span>
							<Typography>자산</Typography>
						</span>
						<span>
							<Typography>-</Typography>
						</span>
						<span>
							<Typography>부채</Typography>
						</span>
						<span>
							<Typography>=</Typography>
						</span>
						<span>
							<Typography>자본</Typography>
						</span>
					</div>
					<List id="classinfo">
						{rank != null &&
							rank.map((item: any, index: number) => {
								return (
									<AppListItem
										index={index}
										name={item.company_name}
										stock={item.stock}
										loan={item.loan}
										loan_interest={item.loan_interest}
										capital={item.capital}
										material_stock={item.material_stock}
										material_loan_stock={item.material_loan_stock}
										license_stock={item.license_stock}
									/>
								);
							})}
						<div className={classes.blank}></div>
					</List>
				</div>

				<div className={classes.footer}>
					<img src="/images/youstarter.png" />
				</div>

				<div className={classes.logoSection}>
					<SIcon type="P" />
				</div>
			</Container>
		</div>
	);
};

const AppListItem: React.FC<any> = (props) => {
	const classes = useStyles();
	const { index, name, stock, loan, loan_interest, capital, material_stock, material_loan_stock, license_stock } = props;
	const AddComma = (num: number) => {
		var regexp = /\B(?=(\d{3})+(?!\d))/g;
		return num.toString().replace(regexp, ',');
	};

	return (
		<ListItem id={index} className={classes.memberInfo}>
			<Box className={classes.buttonLabel}>{index + 1}</Box>
			<Box className={classes.buttonLabel}>{name}</Box>
			<Box className={classes.buttonLabel}>{AddComma(stock + material_stock + license_stock) + '원'}</Box>
			<Box></Box>
			<Box className={classes.buttonLabel}>{AddComma(loan + loan_interest + material_loan_stock) + '원'}</Box>
			<Box></Box>
			<Box className={classes.buttonLabel}>{AddComma(capital + license_stock) + '원'}</Box>
		</ListItem>
	);
};

export default SubAdminOpenRanking;
